import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Annulleret: {{reason}}',
    fulfilled: 'Denne ordre er gennemført',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Ikke accepteret',
    [OrderRejectionReason.ClosingSoon]: 'Lukker snart',
    [OrderRejectionReason.ItemUnavailable]: 'Vare ikke tilgængelig',
    [OrderRejectionReason.OrderTooBig]: 'Ordren er for stor',
    [OrderRejectionReason.CustomerMistake]: 'Kundefejl',
    [OrderRejectionReason.Other]: 'Andet',
    fully_refunded: 'Ordren blev refunderet fuldt ud',
  },
};
